import { gql } from 'graphql-request'
import { GenericBlock } from '../generic'
import { ExcludedPlatforms } from 'app/types/excludedPlatforms'

export const landingMemberQuoteFragment = gql`
  fragment landingMemberQuoteFragment on LandingMemberQuote {
    id
    quote
    memberName
    memberImage {
      url
      sizes {
        square {
          url
        }
      }
    }
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface LandingMemberQuote extends GenericBlock<'LandingMemberQuote'> {
  quote: string
  memberName: string
  memberImage: {
    url: string
    sizes: {
      square: {
        url: string
      }
    }
  }
  excludedPlatforms: ExcludedPlatforms
}

